import React, { useState } from 'react';
import GeneralTab from './full_form/GeneralTab';
import { Tab, Tabs } from '@mui/material';
import { Alert, Backdrop, Box, CircularProgress, IconButton, Snackbar } from '@material-ui/core';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { pink } from '@mui/material/colors';
import ReviewsTab from './full_form/ReviewsTab';
import { observer } from 'mobx-react';
import AmazonTab from './full_form/./AmazonTab';
import FinishTab from './full_form/FinishTab';
import ScraperForm from './ScraperForm';
import GenericSnack from '../../GenericSnack';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import MeliTab from './full_form/MeliTab';
import LinkedBooksTab from './full_form/LinkedBooksTab';

const FullForm = observer(({ mainBookFormStore, userStore, snackStore }) => {
  const [linkedBooksCount, setLinkedBooksCount] = useState(null);

  const handleChangeTab = (event, newValue) => {
    mainBookFormStore.setActiveTab(newValue);
  };

  const getTabIcon = tab => {
    if (mainBookFormStore.tabsErrors[tab]) {
      return <WarningIcon sx={{ color: pink[500] }} />;
    }

    return <CheckCircleIcon color="success" />;
  }

  if (!mainBookFormStore.showFullForm) {
    return (
      <>
        {mainBookFormStore.loading && <Backdrop sx={{ zIndex: 10000 }} open={mainBookFormStore.loading} ><CircularProgress  /></Backdrop>}
        <ScraperForm userStore={ userStore } mainBookFormStore={mainBookFormStore}></ScraperForm>
      </>
    );
  }

  return (
    <div>
      {mainBookFormStore.loading && <Backdrop open={mainBookFormStore.loading}><CircularProgress  /></Backdrop>}
      <GenericSnack snackStore={snackStore} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {mainBookFormStore.formData.id ? (
          <Tabs value={mainBookFormStore.activeTab === 5 ? 5 : false} onChange={handleChangeTab}>
            <Tab value={5} label={linkedBooksCount !== null ? `Livros-filho vinculados (${linkedBooksCount})` : 'Livros-filho vinculados'} />
          </Tabs>
        ) : <Box />}
        <Box display="flex" alignItems="center">
          <IconButton onClick={() => {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
              const range = selection.getRangeAt(0); // Get the first range
              const commonAncestor = range.commonAncestorContainer;
              if (commonAncestor.nodeType === Node.ELEMENT_NODE) {
                const inputsInSelection = commonAncestor.querySelectorAll('input, textarea, select'); // Or more specific selectors
                if (inputsInSelection.length > 0) {
                  inputsInSelection.forEach(input => {
                    const startIndex = input.selectionStart;
                    const endIndex = input.selectionEnd;
                    const selectedText = input.value.substring(startIndex, endIndex);
                    const transformedText = selectedText.toLowerCase();
                    const newValue = input.value.substring(0, startIndex) +
                      transformedText +
                      input.value.substring(endIndex);
                    mainBookFormStore.setFormData(input.name, newValue)
                  });
              }
            }
          }}}><TextDecreaseIcon /></IconButton>
          <Tabs value={mainBookFormStore.activeTab !== 5 ? mainBookFormStore.activeTab : false} onChange={handleChangeTab}>
            <Tab value={0} icon={getTabIcon(0)} iconPosition="start" label="Informações Gerais" />
            <Tab value={1} icon={getTabIcon(1)} iconPosition="start" label="Reviews" />
            <Tab value={2} icon={getTabIcon(2)} iconPosition="start" label="Seller - Amazon" />
            <Tab value={3} icon={getTabIcon(3)} iconPosition="start" label="Seller - Meli" />
            <Tab value={4} icon={getTabIcon(4)} iconPosition="start" label="Finalizar" />
          </Tabs>
        </Box>
      </Box>
      {mainBookFormStore.activeTab === 0 &&
        <GeneralTab mainBookFormStore={mainBookFormStore} userStore={userStore} />}

      {mainBookFormStore.activeTab === 1 &&
        <ReviewsTab mainBookFormStore={mainBookFormStore} />}

      {mainBookFormStore.activeTab === 2 &&
        <AmazonTab mainBookFormStore={mainBookFormStore} />}

      {mainBookFormStore.activeTab === 3 &&
        <MeliTab mainBookFormStore={mainBookFormStore} />}

      {mainBookFormStore.activeTab === 4 && <FinishTab mainBookFormStore={mainBookFormStore} userStore={userStore} />}

      <div hidden={mainBookFormStore.activeTab !== 5}>
        <LinkedBooksTab mainBookFormStore={mainBookFormStore} userStore={userStore} onCountLoaded={setLinkedBooksCount} />
      </div>
    </div>
  );
});

export default FullForm;
